import {Component, OnInit, Input, HostListener, OnDestroy} from '@angular/core';
import {ColumnSortService} from '../../services/column-sort.service';
import {Subscription} from 'rxjs/Subscription';

// tslint:disable:component-selector
@Component({
  selector: '[sortable-column]',
  templateUrl: './sortable-column.component.html'
})
export class SortableColumnComponent implements OnInit, OnDestroy {
  constructor(private sortService: ColumnSortService) {
  }

  private columnSortedSubscription: Subscription;

  // tslint:disable:no-input-rename
  @Input('sortable-column')
  columnName: string;

  @Input('sort-direction')
  sortDirection = '';

  @HostListener('click')
  sort() {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortService.columnSorted({
      sortColumn: this.columnName,
      sortDirection: this.sortDirection,
    });
  }

  ngOnInit() {
    this.columnSortedSubscription = this.sortService.columnSorted$
      .subscribe(event => {
        if (this.columnName !== event.sortColumn) {
          this.sortDirection = '';
        }
      });
  }

  ngOnDestroy() {
    this.columnSortedSubscription.unsubscribe();
  }
}

// tslint:enable:component-selector
// tslint:enable:no-input-rename




// WEBPACK FOOTER //
// ./src/app/shared/directives/sortable-column/sortable-column.component.ts